<div #tripAutocomplete class="trip_autocomplete_container" tamDropDownOutside (clickOutside)="onClickOutside($event)">
    <div class="direction-icon-container">
        <div class="direction-circle">
            <smart-icon name="direction-circle" size="20">
            </smart-icon>
        </div>
        <div class="direction-curve-line showItem">
            <smart-icon name="direction-curve-line">
            </smart-icon>
        </div>
        <div class="direction-bluemark hideItem">
            <smart-icon name="direction-bluemark" size="20">
            </smart-icon>
        </div>
    </div>
    <div class="inputbox" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
        <div class="outerbox">
            <div class="innerbox">
                <input #searchAddress type="text" placeholder="Choose or enter Starting Point" [(ngModel)]="userInput"
                    [title]="userInput" (focus)="showPopup($event)" (keyup)="keyUpHandler()"
                    class="textInput common-input" />

                <kendo-popup class="popup" [anchor]="searchAddress" *ngIf="isPopUpShow">
                    <div class="dropdown" *ngIf="predictionArray && predictionArray.length > 0">
                        <a class="dropdown-content" *ngFor="let prediction of predictionArray">
                            <div class="contact-info" (click)="predictionSelected(prediction)">
                                <div class="contactName" *ngIf="prediction.contact && prediction.contact.name">
                                    {{prediction.contact.name}}<span *ngIf="prediction.selectedAddressType"
                                        class="selectedAddress">({{prediction.selectedAddressType}})</span></div>
                                <div [title]="prediction.selectedAddress" class="selectedAddress">
                                    {{prediction.selectedAddress}}</div>
                            </div>
                        </a> 
                    </div>
                </kendo-popup>
            </div>
            <div class="close-container">
                <smart-icon name="close" size="12" (click)="removeAutocomplete()"></smart-icon>
            </div>
        </div>
        <div class="contact-type"
            *ngIf="currentPrediction&&currentPrediction.contact && currentPrediction.contact.name">
            {{currentPrediction.contact.name}} <span
                *ngIf="currentPrediction.selectedAddressType">({{currentPrediction.selectedAddressType}})</span>
        </div>
        <div [style.visibility]="isShowNearby? 'visible': 'hidden'" class="show-nearby" (click)="clickNearby()">Search
            nearby</div>
    </div>
</div>